/* eslint-disable no-unused-vars */

import { professionalDiplomaHashMap } from '@/components/modal/training-module/request-certificate/components/steps/RequestCertificateStep3';
import { ROLE_ACCESS, USER_PLAN } from '../constant/storage';
import { IAuthResponse } from './auth.interface';
import { IEnterpriseProfileStructureJSON } from './enterprise-profile/enterprise.interface';
import { FolderStatusEnum } from './training.interface';

export enum FollowPageEnum {
  Follower = 'isFollowedBy',
  Following = 'folowers',
}

export enum RoleViewEnum {
  Guest = 'guest',
  Follow = 'follower',
  Owner = 'owner',
}

export type FollowPageType = `${FollowPageEnum}`;

export type RoleViewType = `${RoleViewEnum}`;
export interface IUserProfileData {
  profiles: {
    avatar: string | null;
    cover: string | null;
    bio: string;
    certificate: Object[];
    contact: Object[];
    experience: Object[];
    followers: Object[];
    hasBlueTick: boolean;
    isFollowedBy: Object[];
    isFollowedMe: boolean;
    isFromDoccen: boolean;
    notificationCount: number;
    ownerId: number;
    pendingFollowMe: boolean;
    project: Object[];
    qbankData: {
      avatar: string;
      createdAt: string;
      dateOfBirth: string;
      digitInputTimes: number;
      email: string;
      fullName: string;
      isActive: boolean;
      isNewUser: boolean;
      isVerify: boolean;
      major: string;
      school: string;
      stdId: string;
      updatedAt: string;
      username: string;
    };
    quickStartSkipped: boolean;
    reward: Object[];
    school: Object[];
    scientific: Object[];
    slug: string;
    social: Object[];
    title: string;
    volunteeringActivity: Object[];
    userPlan: USER_PLAN;
    isBizAccount: boolean;
    savedInfo: {
      academicDegree: keyof typeof professionalDiplomaHashMap;
      fullName: string;
    };
    enterprise?: IEnterpriseProfileStructureJSON['structure'];
  };
  viewPermission: RoleViewEnum;
  isAccepted?: boolean;
}

// disable unused for enum
export interface IUser {
  fullName: string;
  schoolName: string;
  major: string;
  workPlace: string;
  department: string;
  position: string;
}
export interface IWebsiteLink {
  link: string;
  viewPermission: 'public' | 'private' | 'protected';
  socialNetwork: string;
}

export interface ISocialLink extends IWebsiteLink {}

export interface IContact {
  contactType: string;
  contactInfo: string;
  viewPermission: 'public' | 'private' | 'protected';
}
export interface IUserSExp {
  workPlace: string;
  department: string;
  position: string;
  startDate: string;
  endDate: string;
  viewPermission: 'public' | 'private' | 'protected';
  experienceId?: string | null;
}

export interface IUserProject {
  projectName: string;
  numberOfMembers: string;
  startDate: string;
  endDate: string;
  description: string;
  link: string;
  position: string;
  mission: string;
  viewPermission: 'public' | 'private' | 'protected';
}

export interface IUserVolunteeringActivity {
  viewPermission: 'public' | 'private' | 'protected';
  organization: string;
  position: string;
  startDate: string;
  endDate: string;
  description: string;
  link: string;
}
export interface IUserIntroduction {
  bio: string;
  fullName?: string;
}
export interface IUserSchool {
  schoolName: string;
  major: string;
  startDate: string;
  endDate: string;
  viewPermission: 'public' | 'private' | 'protected';
  schoolId?: string | null;
}

export interface IGetProfile {
  accessToken: string;
  userId: string;
  requesterUserId: string;
}

export interface IAchievementsInput {
  grantDate: string;
  link: string;
  description: string;
  viewPermission: 'public' | 'private' | 'protected';
}

export interface IScientificPaperInput extends IAchievementsInput {
  scientificName: string;
  publisher: string;
}
export interface IRewardInput extends IAchievementsInput {
  rewardName: string;
  organization: string;
}

export interface ICertificateInput extends IAchievementsInput {
  certificateName: string;
  organization: string;
}

export interface IUserProfileProps {
  initData: IUserProfileData;
  slug: string;
  authData?: IAuthResponse;
}

export enum UserSettingEnum {
  Avatar = 'avatar',
  Experience = 'experience',
  Introduction = 'bio',
  School = 'school',
  Scientific = 'scientific',
  SocialLink = 'social-link',
  Award = 'reward',
  Website = 'website',
  Contact = 'contact',
  Certificate = 'certificate',
  Fullname = 'fullname',
  Project = 'project',
  Volunteer = 'volunteer',
}

export type UserSettingType = `${UserSettingEnum}` | '';

export interface PageMeta {
  page: number;
  limit: number;
}

export interface ISetModal {
  setModal: ({
    isOpen,
    name,
    value,
  }: {
    isOpen: boolean;
    name: UserSettingType;
    value: any;
  }) => void;
}

export interface IDetailProfileInfoFC extends ISetModal {
  data: any;
  roleView: RoleViewType;
}

export interface IUserFullName {
  fullName: string;
  // degree: string;
}

export interface IBioProps {
  data: any;
}

export interface IScreenList {
  user: IUser;
  missingInfo: boolean;
  handleSetValue: Function;
}

export interface ICreateBio {
  bio: string | null;
}

export interface IQuickstart {
  schoolName?: string;
  major?: string;
  workPlace?: string;
  department?: string;
  position?: string;
  username?: string;
}

export interface IUserAvt {
  avatar: File;
}

export interface IUserCover {
  cover: File;
}

export interface ModalType {
  isOpen: boolean;
  name: UserSettingType;
  value: any;
}

export interface FollowModalState {
  isShow: boolean;
  followType: FollowPageType;
}

export interface IInlineModalState {
  inlineModal: {
    isShow: boolean;
    content: string;
  };
}

export interface IHeader {
  roleView: string;
  info: any;
  imgSrc: string;
  fullName: string;
  userName: string;
  handleShare: Function;
  handleToggleBottomModal: Function;
  hasBlueTick: boolean;
}

export interface IBusinessHeader {
  fullName: string;
  imgSrc: string;
  hasBlueTick: boolean;
}

export interface IUserSlug {
  slug: string;
}

export interface IGetSlug {
  accessToken: string;
}

export interface IGetUidAndSlug {
  uid_slug: string | number;
}

export interface IProfileSectionProps {
  roleView: RoleViewType;
  bio: any;
  school: any;
  experience: any;
  certificate: any;
  reward: any;
  scientific: any;
  setModal: any;
  project: any;
  volunteeringActivity: any;
}

export interface IContactSectionProps {
  roleView: RoleViewType;
  social: any;
  contact: any;
  website: any;
  setModal: any;
}

export interface IContactBarProps {
  roleView: RoleViewType;
  social: any;
  contact: any;
  website: any;
  setIsContactModalShown: any;
  refectAfterChangeInformation: Function;
}

export interface IWebsiteInputProps {
  website: any;
  handleSubmit: any;
  isWebsiteEditable: boolean;
  setIsWebsiteEditable: Function;
}

export interface IContactSectionModalProps {
  setIsContactModalShown: any;
  roleView: RoleViewType;
  social: any;
  contact: any;
  website: any;
  setModal: any;
}

export interface IReferralCode {
  referralCode: string;
}

export interface IBusinessProfileGroup {
  id: string;
  name: string;
  status: FolderStatusEnum;
  avatar: string;
  cover: string;
  description: string;
  numOfMembers: number;
  currentUserPermission: ROLE_ACCESS;
  isJoined: boolean;
  isOwnerProfile: boolean;
}

export enum EBizProfile {
  Followed = 'followed',
  UnFollowed = 'unfollowed',
}
export interface IOutstandingBizProfile {
  email: string;
  fullName: string;
  avatar: string;
  cover: string;
  slug: string;
  ownerId: number;
  academicRank: string | null;
  workplace: string;
  phoneNumber: string;
  hasBlueTick: boolean;
  userPlan: string;
  isBizAccount: boolean;
  totalFollowers: number;
  totalFolders: number;
  followStatus: EBizProfile | null;
}
